module.exports = __webpack_public_path__ + "static/media/double-quotes.5b84bee6.svg";